import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SidebarComponent } from './sidebar.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgxPermissionsModule.forRoot()],
  exports: [SidebarComponent],
  declarations: [SidebarComponent],
})
export class SidebarModule {}
